import { createFileRoute } from '@tanstack/react-router';
import { HolderPage } from '../../../receptora/journey/holder-page.tsx';

export const Route = createFileRoute('/receptora/titular')({
  component: HolderPage,
});
